/**
 * Asynchronous SHA-512 hash function.
 * Returns a hex string of the SHA-512 hash of the input.
 *
 * This implementation matches the online sha512 output
 * (e.g., https://emn178.github.io/online-tools/sha512.html)
 */
export const sha512 = async (str: string): Promise<string> => {
  // Convert input string to UTF-8 bytes
  // TextEncoder defaults to UTF-8 encoding
  const encoder = new TextEncoder();
  const data = encoder.encode(str);

  // Compute SHA-512 hash
  const hashBuffer = await window.crypto.subtle.digest("SHA-512", data);

  // Convert ArrayBuffer to hex string
  // (Matches output style of online SHA-512 tools)
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray.map(b => b.toString(16).padStart(2, "0")).join("");
  return hashHex;
};
